import React from "react";
import {
  View,
  Text,
  StyleSheet,
  TextInput,
  useWindowDimensions,
  TouchableOpacity,
  Platform,
  ActivityIndicator,
} from "react-native";
import OptionsList from "./OptionsList";
import GlobalStyles from "./StylenColor";

const QuestionCard = ({
  question,
  currentIndex,
  responses,
  handleOptionSelect,
  handleRemarkChange,
  isLastQuestion,
  isSubmitting,
  handleNext,
  handleSubmit,
}) => {
  const { width } = useWindowDimensions();
  const isWeb = Platform.OS === "web" && width > 768;
  const currentResponse = responses[currentIndex];
  const hasRemark = (currentResponse?.remark || "").trim().length > 0;
  const canProceed = currentResponse?.weight && hasRemark;

  return (
    <View style={[styles.cardContainer, isWeb && styles.webCardContainer]}>
      {isWeb ? (
        // 📦 Desktop web layout: side-by-side
        <View style={styles.webRow}>
          <View style={styles.leftPanel}>
            <Text style={[styles.questionText, styles.questionTextWeb]}>
              {`Q${currentIndex + 1}: ${question.question}`}
            </Text>
            <OptionsList
              options={question.options}
              weights={question.weights}
              selectedWeight={currentResponse?.weight}
              onSelectOption={handleOptionSelect}
            />
          </View>

          <View style={styles.rightPanel}>
            <Text style={styles.remarkLabel}>Remarks (Required)</Text>
            <TextInput
              placeholder="Enter suggestion, proof or remarks (required)"
              multiline
              numberOfLines={8}
              maxLength={300}
              style={[styles.remarkInput, styles.remarkInputWeb]}
              value={currentResponse?.remark || ""}
              onChangeText={handleRemarkChange}
            />
            <View style={{ marginTop: 16 }}>
              {!isLastQuestion ? (
                <TouchableOpacity
                  style={[
                    styles.button,
                    !canProceed && styles.buttonDisabled,
                  ]}
                  onPress={handleNext}
                  disabled={!canProceed}
                >
                  <Text style={styles.buttonText}>Next</Text>
                </TouchableOpacity>
              ) : (
                <>
                  <TouchableOpacity
                    style={[
                      styles.button,
                      (!canProceed || isSubmitting) &&
                        styles.buttonDisabled,
                    ]}
                    onPress={handleSubmit}
                    disabled={!canProceed || isSubmitting}
                  >
                    <Text style={styles.buttonText}>Submit</Text>
                  </TouchableOpacity>
                  {isSubmitting && (
                    <ActivityIndicator
                      size="small"
                      color="#6200EE"
                      style={{ marginTop: 10 }}
                    />
                  )}
                </>
              )}
            </View>
          </View>
        </View>
      ) : (
        // 📱 Mobile and mobile web layout: stacked
        <>
          <Text style={styles.questionText}>
            {`Q${currentIndex + 1}: ${question.question}`}
          </Text>
          <OptionsList
            options={question.options}
            weights={question.weights}
            selectedWeight={currentResponse?.weight}
            onSelectOption={handleOptionSelect}
          />
          <TextInput
            placeholder="Enter suggestion, proof or remarks (required)"
            multiline
            numberOfLines={4}
            maxLength={300}
            style={styles.remarkInput}
            value={currentResponse?.remark || ""}
            onChangeText={handleRemarkChange}
          />
        </>
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  cardContainer: {
    marginBottom: 20,
    padding: 10,
    borderRadius: 8,
    backgroundColor: "#effdee",
    elevation: 2,
  },
  webCardContainer: {
    padding: 20,
  },
  webRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    gap: 20,
  },
  leftPanel: {
    width: "78%",
  },
  rightPanel: {
    width: "20%",
  },
  questionText: {
    fontSize: GlobalStyles.fontSize.md,
    marginBottom: 10,
    color: "#333",
    fontWeight: "500",
    fontFamily: GlobalStyles.GlobalFont.fontFamily,
  },
  questionTextWeb: {
    fontSize: GlobalStyles.fontSize.sm,
  },
  remarkLabel: {
    fontSize: GlobalStyles.fontSize.sm,
    fontWeight: "500",
    marginBottom: 6,
    fontFamily: GlobalStyles.GlobalFont.fontFamily,
    color: "#333",
  },
  remarkInput: {
    borderColor: "#ccc",
    borderWidth: 1,
    borderRadius: 6,
    padding: 10,
    marginTop: 10,
    fontSize: GlobalStyles.fontSize.xs,
    color: "#333",
    fontFamily: GlobalStyles.inpFont.fontFamily,
    width: "100%",
  },
  remarkInputWeb: {
    height: "60%",
    fontSize: GlobalStyles.fontSize.xss,
  },
  button: {
    paddingVertical: 12,
    paddingHorizontal: 24,
    marginTop: 10,
    backgroundColor: GlobalStyles.btnColor.backgroundColor,
    borderRadius: 10,
    alignItems: "center",
  },
  buttonDisabled: {
    backgroundColor: "#accdb0",
  },
  buttonText: {
    color: "#fff",
    fontSize: GlobalStyles.fontSize.btn,
    fontFamily: GlobalStyles.GlobalFont.fontFamily,
  },
});

export default QuestionCard;
